import SettingsComponent from '../components/Settings/Settings';

const Settings = () => {
  return <SettingsComponent />;
};

export default Settings; 